import { AfterViewInit, Component, ElementRef, HostBinding, ViewChild } from '@angular/core';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MapsService, PlacesService, AnalyticsService, LoaderService } from '@box-core/services';
import { LandingPageService } from '@box-pages/pages/landing/landing-page.service';
import { switchMap } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'landing-hero-location',
  templateUrl: './landing-hero-location.component.html',
  styleUrls: ['./landing-hero-location.component.scss']
})
export class LandingHeroLocationComponent implements AfterViewInit {
  @ViewChild('searchInput') searchInput: ElementRef<HTMLInputElement>;

  public placePrediction: google.maps.places.AutocompletePrediction;
  public placePredictions: google.maps.places.AutocompletePrediction[];
  public inputText = '';
  public showEmptyState: boolean;
  private placeResult: google.maps.places.PlaceResult;
  private readonly gaCustomConfig = { source: 'landing' };

  constructor(
    private mapsService: MapsService,
    private placesService: PlacesService,
    private analyticsService: AnalyticsService,
    private landingPageService: LandingPageService,
    private loaderService: LoaderService
  ) {}

  @HostBinding('class') public hostClass = 'landing-hero-location';

  ngAfterViewInit(): void {
    this.searchInput.nativeElement.focus();
  }

  public onInputClick(): void {
    this.analyticsService.addGACustomEvent('input_address', this.gaCustomConfig);
  }

  public onPlaceSearch(): void {
    const inputText = (this.inputText || '').trim();
    this.placePredictions = [];
    delete this.placePrediction;
    delete this.placeResult;
    if (inputText.length < 3) return;

    this.mapsService
      .loadAPI()
      .pipe(switchMap(() => this.placesService.getPlacePredictions(inputText)))
      .subscribe({
        next: (predictions) => {
          this.placePredictions = predictions;
          this.showEmptyState = predictions.length === 0;
        },
        error: (error) => console.error(error)
      });
  }

  public onPlaceSelect(event: MatAutocompleteSelectedEvent): void {
    this.analyticsService.addGACustomEvent('click_address', this.gaCustomConfig);
    if (!event.option.value) return;
    this.placePrediction = event.option.value as google.maps.places.AutocompletePrediction;
    this.inputText = this.placePrediction?.description ?? '';
    this.placePredictions = [];
    this.loaderService.setState(true);
    this.placesService
      .getPlaceDetails(this.placePrediction.place_id)
      .pipe(finalize(() => this.loaderService.setState(false)))
      .subscribe({
        next: (placeResult) => {
          this.placeResult = placeResult;
          this.landingPageService.initiatePlaceSequence(this.placeResult);
        }
      });
  }

  public displayWithFunction(): string {
    /* we override the default mat-autocomplete behaviour since we fill the input from 2 different sources */
    return '';
  }

  public onNavigation(): void {
    this.analyticsService.addGACustomEvent('click_paraggeile', this.gaCustomConfig);
    this.landingPageService.navigateTo({ commands: ['/home'] });
  }

  public onTrackMeClick(): void {
    this.landingPageService.geolocateUser();
    this.analyticsService.addGACustomEvent('click_location', this.gaCustomConfig);
  }
}
